import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import RawPlatMap from '@bd/bdui-platmap';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import numeral from 'numeral';
// import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageIntroBanner from '../../components/PageIntroBanner';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import LotResults from './LotResults';
import MenuFind from '../../components/MenuFind';
// import HomeCard from '../../components/HomeCard';

const PlatMap = withData(
  {
    community: true,
    lots: true,
    homes: true,
  },
  {
    community: true,
  },
)(RawPlatMap);


const styles = css`
  position: relative;
  z-index: 1;
  padding: 0 0 90px 0;
  margin: -45px 0 0 0;

  .leaflet-container {
    background-color: #FFFFFF;
    border: #EEEEEE;
    height: 300px !important;
    @media(min-width: 768px) {
      height: 450px !important;
    }
    @media(min-width: 992px) {
      height: 650px !important;
    }
  }
  .leaflet-popup-content {
    width: 300px;
  }
  .SitePlan_legend {
    list-style: none;
    padding: 0 15px;
  }
  .SitePlan_legendItem {
    display: inline-block;
    margin: 0 15px 0 0;
    font-size: 16px;
    line-height: 24px;
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      width: 18px;
      height: 18px;
      margin: 0 5px 0 0;
      background-color: #000000;
    }
    &-available {
      &::before {
        background-color: #B9A894;
      }
    }
    &-underConstruction {
      &::before {
        background-color: rgb(255,193,7);
      }
    }
    &-availableHome {
      &::before {
        background-color: rgb(17, 162, 18);
      }
    }
    &-sold {
      &::before {
        background-color: rgb(215, 1, 1);
      }
    }
    &-modelHome {
      &::before {
        background-color: rgb(4, 127, 248);
      }
    }
    &-phase6 {
      &::before {
        background-color: purple;
      }
    }
    &-phase7 {
      &::before {
        background-color: teal;
      }
    }
    &-phase8 {
      &::before {
        background-color: navy;
      }
    }
  }
  .PlatMapContainer {
    border: 1px solid #EAEAEA;
  }
  .home-popup {
    margin: 10px;
  }
  .MarkerCard-HomeCard-list {
    display: flex;
    li {
      padding: 0 15px 0 0;
    }
  }
  .MarkerCard-HomeCard {
    .btn-default {
      padding: 20px 20px 20px 0;
    }
  }

`;

const sortOptions = [
  { title: 'Lot Number', field: 'lot' },
  { title: 'Price Low To High', field: 'price' },
  { title: 'Price High To Low', field: 'price', dir: 'desc' },
  { title: 'Address', field: 'address.streetAddress' },
  { title: 'State', field: 'address.addressRegion' },
];

class CommunityOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  render() {
    const { page, communities } = this.props;
    const { sort } = this.state;

    return (
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1="Community Map & Lots"
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuFind />
        <PageIntroBanner
          headline="Lot Availability"
        />
        <div className={styles}>
          <div className="container">
            <div className="row d-flex justify-content-center">
              <ul className="SitePlan_legend">
                <li className="SitePlan_legendItem SitePlan_legendItem-available">Available Lot</li>
                <li className="SitePlan_legendItem SitePlan_legendItem-availableHome">Quick Move-In Homes</li>
                <li className="SitePlan_legendItem SitePlan_legendItem-modelHome">Model Home</li>
                <li className="SitePlan_legendItem SitePlan_legendItem-sold">Sold</li>
              </ul>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="w-100 PlatMapContainer">
                <PlatMap
                  shapeStatusStyles={{
                    home: {
                      active: {
                        opacity: 0.7,
                        fillOpacity: 0.5,
                        color: 'rgb(17, 162, 18)',
                      },
                      'under-construction': {
                        opacity: 0.7,
                        fillOpacity: 0.5,
                        color: 'rgb(255,193,7)',
                      },
                      sold: {
                        opacity: 0.7,
                        fillOpacity: 0.4,
                        color: 'rgb(215, 1, 1)',
                      },
                      pending: {
                        opacity: 0.7,
                        fillOpacity: 0.4,
                        color: 'rgb(215, 1, 1)',
                      },
                    },
                    lot: {
                      active: {
                        opacity: 0.7,
                        fillOpacity: 0.3,
                        color: 'rgb(185, 168, 148)',
                      },
                      'under-construction': {
                        opacity: 0.7,
                        fillOpacity: 0.5,
                        color: 'rgb(255,193,7)',
                      },
                      sold: {
                        opacity: 0.7,
                        fillOpacity: 0.4,
                        color: 'rgb(215, 1, 1)',
                      },
                      pending: {
                        opacity: 0.7,
                        fillOpacity: 0.4,
                        color: 'rgb(215, 1, 1)',
                      },
                      default: {
                        color: 'gray',
                      },
                    },
                    'phase-6-available-summer-2019': {
                      color: 'purple',
                    },
                    'model-home': {
                      opacity: 0.7,
                      fillOpacity: 0.7,
                      color: 'rgb(4, 127, 248)',
                    },
                    'phase-7': {
                      color: 'teal',
                    },
                    'phase-8': {
                      color: 'navy',
                    },
                    sold: {
                      opacity: 0.7,
                      fillOpacity: 0.4,
                      color: 'rgb(215, 1, 1)',
                    },
                  }}
                  shapes
                  boundarySize={1}
                  community={communities[0]}
                  popup={({ marker }) => (
                    <div className="home-popup">
                      {
                        marker.type === 'home' &&
                        <div>
                          {
                            marker.status === 'Active' &&
                            <div className="MarkerCard-HomeCard">
                              <h5>Available Home<br /></h5>
                              <h6 className="MarkerPrice">
                                {
                                  get(marker, 'price') &&
                                  <span className="PriceValue">{numeral(get(marker, 'price')).format('$0,0')}</span>
                                }
                                {
                                  !get(marker, 'price') &&
                                  <span className="PriceValue">Price Coming Soon!</span>
                                }
                              </h6>
                              <h6 className="MarkerAddress">
                                <span>{get(marker, 'address.streetAddress')}</span><br />
                                <span>{get(marker, 'address.addressLocality')}, {get(marker, 'address.addressRegion')}</span>
                              </h6>
                              <div>
                                <ul className="list-unstyled MarkerCard-HomeCard-list">
                                  <li className="MarkerCard-HomeCard-listItems">
                                    <span className="MarkerBed">{get(marker, 'beds')}</span>
                                    <span className="MarkerBed-text"> Beds</span>
                                  </li>
                                  <li>
                                    <span className="">{get(marker, 'bathsFull')} {get(marker, 'bathsHalf', 0) > 0 && '.5'}</span>
                                    <span className=""> Baths</span>
                                  </li>
                                  <li>
                                    <span className="HomeCard_iconListValue">{numeral(get(marker, 'sqft')).format('0,0')}</span>
                                    <span className="HomeCard_iconListLabel"> SQ FT</span>
                                  </li>
                                </ul>
                              </div>
                              <div className="display-flex">
                                <span className="pr-3">
                                  <Link className="btn-default" name="home-detail" home={marker}>
                                    View Details
                                  </Link>
                                </span>
                                <span>
                                  {
                                    get(marker, 'custom_floor_plans') &&
                                    <a className="btn-default" href={get(marker, 'custom_floor_plans.contentUrl')} target="_blank" rel="naopener noreferrer">
                                      Floor Plan Brochure
                                    </a>
                                  }
                                </span>
                              </div>
                            </div>
                          }
                          {
                            (marker.status !== 'Active' &&
                            marker.status !== 'Sold' &&
                            marker.status !== 'Pending' &&
                            marker.status !== 'Under Construction') &&
                            <div>
                              Model Home<br />
                              {marker.address.streetAddress}
                            </div>
                          }
                        </div>
                      }
                      {
                        marker.type === 'lot' &&
                        <div>
                          <span>
                            {
                              marker.status === 'Under Construction' &&
                              <div>
                                Home Under Construction<br />
                                {marker.address.streetAddress}
                              </div>
                            }
                            {
                              marker.status === 'Active' &&
                              <div>
                                <h5>Available Lot<br /></h5>
                                <h6 className="MarkerPrice">
                                  {
                                    get(marker, 'price') &&
                                    <span className="PriceValue">{numeral(get(marker, 'price')).format('$0,0')}</span>
                                  }
                                  {
                                    !get(marker, 'price') &&
                                    <span className="PriceValue">Price Coming Soon!</span>
                                  }
                                </h6>
                                {
                                  marker.lot &&
                                  <div>Lot Number: {get(marker, 'lot')}</div>
                                }
                                <div>{marker.address.streetAddress}</div>
                                {
                                  get(marker, 'description') &&
                                  <div className="py-2">
                                    {marker.description}
                                  </div>
                                }
                                <div>
                                  <ul className="list-unstyled MarkerCard-HomeCard-list">
                                    {
                                      get(marker, 'beds') &&
                                      <li className="MarkerCard-HomeCard-listItems">
                                        <span className="MarkerBed">{get(marker, 'beds')}</span>
                                        <span className="MarkerBed-text"> Beds</span>
                                      </li>
                                    }
                                    {
                                      get(marker, 'bathsFull') &&
                                      <li>
                                        <span className="">{get(marker, 'bathsFull')} {get(marker, 'bathsHalf', 0) > 0 && '.5'}</span>
                                        <span className=""> Baths</span>
                                      </li>
                                    }
                                    {
                                      get(marker, 'sqft') &&
                                      <li>
                                        <span className="HomeCard_iconListValue">{numeral(get(marker, 'sqft')).format('0,0')}</span>
                                        <span className="HomeCard_iconListLabel"> SQ FT</span>
                                      </li>
                                    }
                                  </ul>
                                </div>
                              </div>
                            }
                            {
                              marker.status === 'Sold' &&
                              <div>
                                Sold<br />
                                {marker.address.streetAddress}
                              </div>
                            }
                          </span>
                        </div>
                      }
                    </div>
                  )}
                  tooltip={marker => (
                    <div>
                      {
                        marker.type === 'home' &&
                        <span>
                          {
                            marker.status === 'Active' &&
                            <div>
                              Available Home<br />
                              {
                                get(marker, 'price') &&
                                <span className="PriceValue">{numeral(get(marker, 'price')).format('$0,0')} <br /></span>
                              }
                              {marker.address.streetAddress}
                            </div>
                          }
                          {
                            (marker.status !== 'Active' &&
                            marker.status !== 'Sold' &&
                            marker.status !== 'Pending' &&
                            marker.status !== 'Under Construction') &&
                            <div>
                              Model Home<br />
                              {marker.address.streetAddress}
                            </div>
                          }
                        </span>
                      }
                      {
                        marker.isLot &&
                        <span>
                          {
                            marker.status === 'Under Construction' &&
                            <div>
                              Home Under Construction<br />
                              {marker.address.streetAddress}
                            </div>
                          }
                          {
                            marker.status === 'Active' &&
                            <div>
                              Available Lot<br />
                              {
                                get(marker, 'price') &&
                                <div className="MarkerPrice">
                                  {numeral(get(marker, 'price')).format('$0,0')}<br />
                                </div>
                              }
                              {
                                marker.lot &&
                                <div>Lot Number: {get(marker, 'lot')}<br /></div>
                              }
                              <div>{marker.address.streetAddress}</div>
                              {
                                get(marker, 'description') &&
                                <div className="py-2">
                                  {marker.description}
                                </div>
                              }
                              <div>
                                <ul className="list-unstyled MarkerCard-HomeCard-list">
                                  {
                                    get(marker, 'beds') &&
                                    <li className="MarkerCard-HomeCard-listItems">
                                      <span className="MarkerBed">{get(marker, 'beds')}</span>
                                      <span className="MarkerBed-text"> Beds</span>
                                    </li>
                                  }
                                  {
                                    get(marker, 'bathsFull') &&
                                    <li>
                                      <span className="">{get(marker, 'bathsFull')} {get(marker, 'bathsHalf', 0) > 0 && '.5'}</span>
                                      <span className=""> Baths</span>
                                    </li>
                                  }
                                  {
                                    get(marker, 'sqft') &&
                                    <li>
                                      <span className="HomeCard_iconListValue">{numeral(get(marker, 'sqft')).format('0,0')}</span>
                                      <span className="HomeCard_iconListLabel"> SQ FT</span>
                                    </li>
                                  }
                                </ul>
                              </div>
                            </div>
                          }
                          {
                            marker.status === 'Sold' &&
                            <div>
                              Sold<br />
                              {marker.address.streetAddress}
                            </div>
                          }
                        </span>
                      }
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        <LotResults sort={sort} />
      </PageWrapper>
    );
  }
}

CommunityOverview.propTypes = {
  page: PropTypes.object.isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    communities: true,
    page: 'community_maps_and_lots',
  },
  {
    required: {
      communities: true,
    },
    ifMissing404: true,
  },
)(CommunityOverview);



// WEBPACK FOOTER //
// ./src/pages/CommunityMap/index.js